export type PublicEventDisplayType = "match" | "entrainement" | "tournoi" | "general";

const eventTypePrefixPatterns: Record<string, RegExp> = {
  match: /^Match\s+(de\s+)?/i,
  entrainement: /^Entra[iî]nement\s+/i,
  tournoi: /^Tournoi\s+(de\s+)?/i,
};

export function getPublicEventDisplayType(type: string): PublicEventDisplayType | null {
  switch (type) {
    case "MATCH":
      return "match";
    case "TRAINING":
      return "entrainement";
    case "TOURNAMENT":
      return "tournoi";
    case "GENERAL":
      return "general";
    default:
      return null;
  }
}

export function getEventDisplayTitle(title: string, type: string) {
  const trimmedTitle = title.trim();
  const pattern = eventTypePrefixPatterns[type];
  const cleanedTitle = pattern ? trimmedTitle.replace(pattern, "").trim() : trimmedTitle;

  return cleanedTitle || trimmedTitle;
}
